import GrpcService, { PlatformAdminApi } from 'src/services/GrpcService';

import {
  ICreate,
  ISearch,
  IUpdate,
  IRestore,
  IFindById,
  IRemove,
} from 'src/services/ServiceLocator/ServiceLocator.interface';
import { RequestController } from 'src/utils/decorators/request-controller';

class AppServiceProvider implements ISearch, ICreate, IUpdate, IRestore, IFindById, IRemove {
  @RequestController({ logger: true, retry: true, debounce: true })
  search(params: PlatformAdminApi.IAppSearchRequest): Promise<PlatformAdminApi.AppSearchResponse> {
    return GrpcService.AppService.Search(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  create(params: PlatformAdminApi.IAppCreateRequest): Promise<PlatformAdminApi.AppResponse> {
    return GrpcService.AppService.Create(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  update(params: PlatformAdminApi.IAppUpdateRequest): Promise<PlatformAdminApi.AppResponse> {
    return GrpcService.AppService.Update(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  restore(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.AppResponse> {
    return GrpcService.AppService.Restore(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  remove(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.AppResponse> {
    return GrpcService.AppService.Remove(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  findById(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.AppResponse> {
    return GrpcService.AppService.FindById(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  regenerateSecrets(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.AppResponse> {
    return GrpcService.AppService.RegenerateSecret(params);
  }
}

export const appServiceProvider = new AppServiceProvider();
export type TAppServiceProvider = typeof appServiceProvider;
